export default {
      id: "shorting-down-usage",
      viewBox: "0 0 20 11",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#shorting-down",
      toString: function () {
        return this.url;
      }
    }